<fury-list>
    <div class="table table_container">
      <table mat-table [dataSource]="dataSource">
       <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Created At</th>
        <td mat-cell *matCellDef="let element">
            {{ commonService.convertDate( element?.createdAt) | date : "MMM-dd-YYYY h:mm a"}}
        </td>
      </ng-container>

      <ng-container matColumnDef="fileClaimNumber">
        <th mat-header-cell *matHeaderCellDef>Claim Number</th>
        <td mat-cell *matCellDef="let element">
            {{element?.fileClaimNumber}}
        </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef>First Name</th>
          <td mat-cell *matCellDef="let element">
              {{element?.firstName}}
          </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef>Last Name</th>
          <td mat-cell *matCellDef="let element">
              {{element?.lastName}}
          </td>
      </ng-container>

      <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef>Phone Number</th>
          <td mat-cell *matCellDef="let element">
              {{element?.phoneNumber | mask: '(000) 000-0000'}}
          </td>
      </ng-container>
      <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef>Email Address</th>
          <td mat-cell *matCellDef="let element">
              {{element?.emailAddress}}
          </td>
      </ng-container>
      <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>Address</th>
          <td mat-cell *matCellDef="let element">
              {{element?.propertyAddress?.address}}
          </td>
      </ng-container>
      <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>City</th>
          <td mat-cell *matCellDef="let element">
              {{element?.propertyAddress?.city}}
          </td>
      </ng-container>
      <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>State</th>
          <td mat-cell *matCellDef="let element">
              {{element?.propertyAddress?.state}}
          </td>
      </ng-container>
      <ng-container matColumnDef="zip">
          <th mat-header-cell *matHeaderCellDef>Zip</th>
          <td mat-cell *matCellDef="let element">
              {{element?.propertyAddress?.zip}}
          </td>
      </ng-container>

      <ng-container matColumnDef="agreementNumber">
        <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
        <td mat-cell *matCellDef="let element">
            {{element?.agreementNumber}}
        </td>
    </ng-container>
  
      <ng-container matColumnDef="coveredItem">
          <th mat-header-cell *matHeaderCellDef>Cover Item</th>
          <td mat-cell *matCellDef="let element">
              {{element?.coveredItem}}
          </td>
      </ng-container>

      <ng-container matColumnDef="transactionId">
        <th *matHeaderCellDef mat-header-cell>Transaction Id</th>
        <td mat-cell *matCellDef="let element">
          {{element?.paymentDetails?.transactionId}}
      </td>
    </ng-container>
    <ng-container matColumnDef="cardType">
      <th *matHeaderCellDef mat-header-cell>Card Type</th>
      <td mat-cell *matCellDef="let element">
        {{element?.paymentDetails?.cardType}}
    </td>
  </ng-container>
  <ng-container matColumnDef="amount">
      <th *matHeaderCellDef mat-header-cell>Copayment Fee</th>
      <td mat-cell *matCellDef="let element">
        ${{element?.paymentDetails?.amount | number}}
    </td>
  </ng-container>

  <ng-container matColumnDef="availability">
      <th *matHeaderCellDef mat-header-cell>Availability</th>
      <td mat-cell *matCellDef="let element">
        {{element?.availability}}
    </td>
  </ng-container>
  <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell>Status</th>
      <td mat-cell *matCellDef="let element">
        {{element?.status}}
    </td>
  </ng-container>
      
  
        <ng-container matColumnDef="actions" stickyEnd>
          <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
          <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
            <button
              type="button"
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before" class="menu_list">
              <button mat-menu-item *ngIf="editorAccess" (click)="handleViewClaim(row)">
                <span>View Claim</span>
              </button>
              <button mat-menu-item (click)="handleClaimPrioritizationModal(row)" *ngIf="row?.openClaimStatuses && editorAccess">
                <span>Claim  Prioritization</span>
            </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="handleAddNotes(row)">
                <span>Add Note</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="handleAddSpecialRequest(row)">
                <span>Add Special Request</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="handleAddFeedback(row)">
                <span>Add Feedback</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="handlePaymentInfo(row)">
                <span>Payout Information</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignCurrentUser')">
                <span>Assign Current User</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignClaimsConcierge')">
                <span>Assign Claims Concierge</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignCoordinator')">
                <span>Assign Coordinator</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignSupervisor')">
                <span>Assign Supervisor</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignPurchaser')">
                <span>Assign Purchaser</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'assignOrEditTechnician')">
                <span>Assign Technician</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'addOutcome')">
                <span>Add Outcome</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'addPayout')">
                <span>Add Payout</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'recall')">
                <span>Recall</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'chargeCopay')">
                <span>Charge Copay</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'payCustomer')">
                <span>Pay Customer</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'payTechnician')">
                <span>Pay Technician</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'orderReplacement')">
                <span>Order Replacement</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'escalateClaim')">
                <span>Escalate Claim</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'orderParts')">
                <span>Order Parts</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'updateClaimInfo')">
                <span>Update Claim Info</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess && row?.isTechnicianAssigned" (click)="openActionModal(row, 'addTechnicianSchedule')">
                <span>Add Technician Schedule</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess && row?.isCompanyAssigned" (click)="handleViewAssignedTechnician(row)">
                <span>View Assigned Technician</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="redirectChangeStatusPage(row)">
                <span>Change Status</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="handleSendEmail(row)">
                <span>Send an email</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess" (click)="openActionModal(row, 'uploadDiagnosis')">
                <span>Upload Diagnosis</span>
              </button>
              <button mat-menu-item *ngIf="editorAccess && row?.status !== 'Cancelled'" (click)="openActionModal(row, 'cancelClaim')">
                <span>Cancel Claim</span>
              </button>
           
            </mat-menu>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        *ngIf="!dataSource?.length"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
    </div>
  </fury-list>
  